/* eslint-disable */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography, Box, TextField, Button,Divider } from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { LoadingButton } from '@mui/lab';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import backArrow from '../../../assets/logo/Arrow.svg';
import StatusAlert from './StatusAlert';
import mailSent from '../../../assets/Images/email.png';
import resetPassword from '../../../assets/logo/restPassword.jpg'

const inputSx = {
  '& input::placeholder': { fontSize: '0.85rem' },
  '& .MuiOutlinedInput-root': {
    borderRadius: '30px',
    '& fieldset': {
      borderColor: 'transparent',
      boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    },
    '& input:-webkit-autofill': {
      boxShadow: '0 0 0 1000px #fff inset !important',
      WebkitTextFillColor: '#000 !important',
      transition: 'background-color 5000s ease-in-out 0s',
    },
  },
};

/* ─────────────────────────────────────────────────
   ForgotPasswordForm
───────────────────────────────────────────────── */
export function ForgotPasswordForm({
  savedEmail,
  forgetloading,
  showEmailNotRegistered,
  logoSrc,
  onSubmit,
  onBack,
  statusAlert,
  onDismissAlert,
}) {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={{ email: savedEmail || '' }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .required('Please enter a valid email ID !')
          .email('Please enter a valid Email ID!'),
      })}
      onSubmit={onSubmit}
    >
      {({ errors, handleBlur, touched, values, setFieldValue }) => (
        <Form>
          <Grid container spacing={2}>

            <Grid item xs={12}>
              <img
                src={logoSrc}
                alt="logo"
                style={{ display: 'block', margin: 'auto', height: '48px', width: '102px' }}
              />
              <Typography
                color="#000000"
                align="left"
                variant="h4"
                sx={{
                  textAlign: 'center',
                  fontSize: { md: '22px', lg: '23px !important' },
                  marginTop: '12px',
                  marginBottom: '0px !important',
                }}
              >
                {t('forget_password_keySkillset')}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  textAlign: 'center',
                  color: '#ababab',
                  fontWeight: 500,
                  fontSize: { xs: '12.5px !important' },
                  marginTop: { xs: '5px !important' },
                }}
              >
                No worries, we&apos;ll send you reset instructions
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                style={{ color: '#333', paddingTop: '10px', fontWeight: 500, marginLeft: '10px', marginBottom: '4px' }}
              >
                Email Address <span style={{ color: 'red' }}>*</span>
              </Typography>
              <TextField
                fullWidth
                id="forgot-email"
                placeholder={t('register_email')}
                name="email"
                variant="outlined"
                color="success"
                sx={inputSx}
                onChange={(e) => {
                  setFieldValue('email', e.target.value.trim());
                }}
                onBlur={handleBlur}
                error={Boolean(touched.email && errors.email)}
                helperText={touched.email && t(errors.email)}
                value={values.email}
                InputProps={{
                  endAdornment: (
                    <IconButton>
                      <EditIcon fontSize="small" style={{ color: '#BCBCBC' }} />
                    </IconButton>
                  ),
                }}
              />
            </Grid>

            {showEmailNotRegistered && (
              <Grid item xs={12}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    textAlign: 'center',
                    color: '#ff804c',
                    fontWeight: 500,
                    fontSize: { xs: '12.5px !important' },
                    marginTop: { xs: '5px !important' },
                  }}
                >
                  * Your email is not registered on keySkillset yet. Please register to continue! *
                </Typography>
              </Grid>
            )}
            {statusAlert && (
              <Grid item xs={12}>
                <StatusAlert
                  alert={statusAlert}
                  onDismiss={onDismissAlert}
                />
              </Grid>
            )}

            <Grid item xs={12} container justifyContent="flex-start" sx={{ marginTop: 2, marginBottom: 5 }}>
              <LoadingButton
                size="medium"
                type="submit"
                variant="contained"
                loading={forgetloading}
                id="resetButton"
                sx={{
                  borderRadius: '30px !important',
                  background: '#00b673',
                  width: '100%',
                  '&:hover': { backgroundColor: '#00b673 !important' },
                }}
              >
                {t('reset_password')}
              </LoadingButton>
              <Button
                sx={{ color: '#004222ED !important', width: '100%', marginTop: '8px', '&:hover': { background: 'none !important' } }}
                onClick={onBack}
              >
                <img src={backArrow} alt="Back" style={{ width: '22px', height: '20px', marginRight: '5px' }} />
                {t('back_to_login')}
              </Button>
            </Grid>

          </Grid>
        </Form>
      )}
    </Formik>
  );
}

export function ResetLinkSent({ forgetEmail, loading, logoSrc, onTryAgain, onBack }) {
  const { t } = useTranslation();

  return (
  
      <Grid container spacing={2} style={{  width: '100%', overflowX: 'hidden',display: 'flex', alignContent: 'center', height: '585px !important'}}>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <img
            src={logoSrc}
            alt="logo"
            style={{ display: "block", margin: "auto", height: "48px", width: "102px" }}
          />
          <Typography color="#000" align="center" variant="h4" sx={{ mt: 2, mb: 1 }}>
            {t("email_sent")}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Divider />
        </Grid>

        <Grid item xs={12}>
          <Typography color="#000" align="center" sx={{ mt: 2 }}>
            {t("email_context1")} 
            <strong
      style={{
        wordBreak: "break-all",   
        display: "inline-block",  
        maxWidth: "100%",        
      }}
    >
      {forgetEmail}
    </strong>
            <br />
            {t("email_context2")}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography color="#000" align="center" sx={{ mt: 1 }}>
            {t("email_failed")}{" "}
            <a
              href="mailto:contact@keyskillset.com"
              style={{ fontWeight: "bold", color: "#000" }}
            >
              contact@keyskillset.com
            </a>
          </Typography>
        </Grid>

        <Grid item xs={12} sx={{ mt: 3 }}>
          <LoadingButton
            fullWidth
            size="medium"
            variant="contained"
            loading={loading}
            id="sendEmailButton"
            sx={{ borderRadius: "30px", background: "#00b673" }}
            onClick={onTryAgain}
          >
            {t("try_again")}
          </LoadingButton>
        </Grid>

        <Grid item xs={12}>
          <Button
            fullWidth
            sx={{
              color: "#004222ED",
              "&:hover": { background: "none" },
            }}
            onClick={onBack}
          >
            <img
              src={backArrow}
              alt="Back"
              style={{ width: "22px", height: "20px", marginRight: "5px" }}
            />
            {t("back_to_login")}
          </Button>
        </Grid>
      </Grid>
  );
}


/* ─────────────────────────────────────────────────
   EmailVerification
───────────────────────────────────────────────── */
export function EmailVerification({ resendEmailLoading, logoSrc, onResend, onBack }) {
  const { t } = useTranslation();

  return (
    <Grid
      container
      spacing={2}
      sx={{ display: 'flex', alignContent: 'center', height: '585px !important' }}
    >
      <Grid item xs={12}>
        <img
          src={logoSrc}
          alt="logo"
          style={{ display: 'block', margin: 'auto', height: '48px', width: '102px' }}
        />
        <Typography
          color="#000000"
          align="center"
          variant="h4"
          sx={{
            fontSize: { md: '22px', lg: '23px !important' },
            marginTop: '20px',
            marginBottom: '25px !important',
            lineHeight: '1.1 !important',
          }}
        >
          Open your inbox and verify your email ID
        </Typography>
        <ul style={{ marginLeft: '30px' }}>
          <li style={{ fontSize: '12px', color: '#000', fontWeight: 500, marginTop: '5px' }}>
            To activate your keySkillset account, we first need to verify your email ID.{' '}
            <b>Please check your inbox!</b>
          </li>
          <li style={{ fontSize: '12px', color: '#000', fontWeight: 500, marginTop: '5px' }}>
            If you haven&apos;t received it, please check spam or junk or recycle bin if you have accidentally deleted it.
          </li>
        </ul>
      </Grid>

      <Grid item xs={12} container justifyContent="flex-start" style={{ paddingTop: '0px' }}>
        <LoadingButton
          size="medium"
          type="button"
          variant="contained"
          id="resendEmail"
          loading={resendEmailLoading}
          onClick={onResend}
          sx={{
            height: '38px',
            paddingTop: '2px',
            lineHeight: '1.1',
            width: '100% !important',
            backgroundColor: '#52c28c',
            borderRadius: '30px',
            marginTop: '30px',
            '&:hover': { backgroundColor: '#52c28c !important', color: '#fff' },
          }}
        >
          {t('Resend Email')}
        </LoadingButton>
      </Grid>

      <Grid item xs={12} sx={{ paddingTop: 1 }}>
        <Button
          sx={{ color: '#004222ED !important', width: '100%', marginTop: '0px', '&:hover': { background: 'none !important' } }}
          onClick={onBack}
        >
          <img src={backArrow} alt="Back" style={{ width: '22px', height: '20px', marginRight: '5px' }} />
          {t('Back to Login')}
        </Button>
      </Grid>
    </Grid>
  );
}

/* ─────────────────────────────────────────────────
   ResetPasswordForm
───────────────────────────────────────────────── */
export function ResetPasswordForm({
  passwordValue,
  confirmPasswordValue,
  setPasswordValue,
  setConfirmPasswordValue,
  passwordError,
  setPasswordError,
  showPasswordLengthError,
  setShowPasswordLengthError,
  showPasswordMismatchError,
  setShowPasswordMismatchError,
  changePasswordLoading,
  logoSrc,
  onSubmit,
  onBack,
}) {
  const { t } = useTranslation();
  const [resetVisible, setResetVisible] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);

  const resetInputSx = {
    marginTop: '5px',
    borderRadius: '30px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '30px',
      '& fieldset': {
        borderColor: 'transparent',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
      },
      '& input:-webkit-autofill': {
        boxShadow: '0 0 0 1000px #fff inset !important',
        WebkitTextFillColor: '#000 !important',
        transition: 'background-color 5000s ease-in-out 0s',
      },
    },
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <img
          src={logoSrc}
          alt="logo"
          style={{ display: 'block', margin: 'auto', height: '48px', width: '102px' }}
        />
        <Typography color="#000000" align="center" variant="h4">
          {t('password_reset')}
        </Typography>
      </Grid>

      {/* New Password */}
      <Grid item xs={12}>
        <Typography variant="subtitle1" style={{ color: '#333', fontWeight: 500, marginLeft: '10px' }}>
          New Password <span style={{ color: 'red' }}>*</span>
        </Typography>
        <TextField
          fullWidth
          id="new-password"
          sx={resetInputSx}
          variant="outlined"
          color="success"
          placeholder={t('New Password')}
          type={resetVisible ? 'text' : 'password'}
          onChange={(e) => {
            setPasswordValue(e.target.value.trim());
            setPasswordError({ pasErr: '' });
            setShowPasswordLengthError(false);
            setShowPasswordMismatchError(false);
          }}
          value={passwordValue}
          helperText={passwordError.pasErr || ''}
          FormHelperTextProps={{ sx: { color: 'red' } }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setResetVisible((v) => !v)}>
                  {resetVisible ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      {/* Confirm Password */}
      <Grid item xs={12}>
        <Typography
          variant="subtitle1"
          style={{ color: '#333', fontWeight: 500, marginLeft: '10px', marginBottom: '0px' }}
        >
          Confirm Password <span style={{ color: 'red' }}>*</span>
        </Typography>
        <TextField
          fullWidth
          id="confirm-password"
          sx={resetInputSx}
          variant="outlined"
          color="success"
          placeholder="Confirm Password"
          type={confirmVisible ? 'text' : 'password'}
          onChange={(e) => {
            setConfirmPasswordValue(e.target.value.trim());
            setPasswordError({ conPassErr: '' });
            setShowPasswordLengthError(false);
            setShowPasswordMismatchError(false);
          }}
          value={confirmPasswordValue}
          helperText={passwordError.conPassErr || ''}
          FormHelperTextProps={{ sx: { color: 'red' } }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setConfirmVisible((v) => !v)}>
                  {confirmVisible ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      {showPasswordLengthError && (
        <Grid item xs={12} container sx={{ justifyContent: 'center', paddingTop: '5px !important' }}>
          <Typography
            variant="subtitle1"
            sx={{ textAlign: 'center', color: '#ff804c', fontWeight: 500, fontSize: { xs: '12.5px !important' } }}
          >
            * Please enter a password with more than 4 characters *
          </Typography>
        </Grid>
      )}

      {showPasswordMismatchError && (
        <Grid item xs={12} container sx={{ justifyContent: 'center' }}>
          <Typography
            variant="subtitle1"
            sx={{ textAlign: 'center', color: '#ff804c', fontWeight: 500, fontSize: { xs: '12.5px !important' } }}
          >
            * The passwords you have entered do not match! *
          </Typography>
        </Grid>
      )}

      <Grid item xs={12} container>
        <LoadingButton
          size="medium"
          type="button"
          variant="contained"
          loading={changePasswordLoading}
          sx={{
            borderRadius: '30px !important',
            background: '#00b673',
            lineHeight: '1.2',
            width: '100%',
            padding: '10px',
            '&:hover': { backgroundColor: '#00b673 !important' },
          }}
          onClick={onSubmit}
        >
          {t('password_change')}
        </LoadingButton>
      </Grid>

      <Button
        sx={{ color: '#004222ED !important', width: '100%', marginTop: '12px', marginLeft: '24px', '&:hover': { background: 'none !important' } }}
        onClick={onBack}
      >
        <img src={backArrow} alt="Back" style={{ width: '22px', height: '20px', marginRight: '5px' }} />
        {t('Back to Login')}
      </Button>
    </Grid>
  );
}